const de = {
  'app.name': 'AI Craft Studio',
  'nav.signIn': 'Anmelden',
  'nav.signOut': 'Abmelden',
  'nav.signingIn': 'Anmeldung läuft…',
  'nav.loading': 'Wird geladen…',
  'nav.backToDashboard': 'Zurück zum Dashboard',
  'nav.back': 'Zurück',
  'nav.language': 'Sprache',

  'credits.label': 'Guthaben: {count}',
  'credits.loading': 'Guthaben: —',
  'credits.buyMore': 'Guthaben kaufen',
  'credits.tooltipBuy': 'Klicken, um Guthaben zu kaufen',
  'credits.tooltipLoading': 'Guthaben wird geladen',

  'auth.title': 'Zum Fortfahren anmelden',
  'auth.subtitle': 'Melde dich mit Google an, um dein Gratisguthaben zu erhalten und deine Nutzung zu verfolgen',
  'auth.google': 'Weiter mit Google',
  'auth.signOutFailed': 'Abmelden nicht möglich. Bitte versuche es erneut.',
  'auth.signInFailed': 'Anmelden nicht möglich. Bitte versuche es erneut.',

  'landing.headline': 'Mach das Foto, das du nie gemacht hast.',
  'landing.sub': 'Melde dich an, um zu starten. Die ersten drei Credits gehen auf uns.',
  'landing.note': 'Ein Credit pro Bild – berechnet erst, wenn das Bild da ist.',

  'dash.eyebrow': 'Werkzeuge',
  'dash.headline': 'Mach das Foto, das du nie gemacht hast.',
  'dash.sub': 'Wähle ein Werkzeug. Jedes kostet einen Credit, und nur wenn es klappt.',

  'tool.arrow.name': 'Arrow Vision',
  'tool.arrow.transform': 'Karte → Blick',
  'tool.arrow.desc': 'Setze einen Pfeil irgendwo auf die Karte und sieh, wie der Blick von dort aussieht.',
  'tool.person.name': 'Personen entfernen',
  'tool.person.transform': 'Menge → leer',
  'tool.person.desc': 'Nimm die Fremden aus dem Foto und behalte den Ort, an dem du warst.',
  'tool.clothing.name': 'Virtuelle Anprobe',
  'tool.clothing.transform': 'Kleidung → du',
  'tool.clothing.desc': 'Probier ein Kleidungsstück an, bevor du dich zum Kauf entscheidest.',

  'upload.title': 'Bild hochladen',
  'upload.hint': 'Klicken, um ein Bild zu wählen, oder hierher ziehen',
  'upload.formats': 'Formate: JPG, PNG, GIF • Maximal 10 MB',
  'upload.person': 'Foto der Person hochladen',
  'upload.clothing': 'Foto des Kleidungsstücks hochladen',
  'upload.selectImage': 'Klicken, um ein Bild zu wählen',
  'upload.formatsShort': 'JPG, PNG — max. 10 MB',
  'upload.tooLarge': 'Das Bild ist größer als 10 MB. Bitte wähle ein kleineres.',
  'upload.notImage': 'Diese Datei ist kein Bild. Bitte wähle ein JPG oder PNG.',

  'action.generate': 'Erzeugen',
  'action.generating': 'Wird erzeugt…',
  'action.download': 'Herunterladen',
  'action.share': 'Teilen',
  'action.delete': 'Löschen',
  'action.cancel': 'Abbrechen',
  'action.tryAgain': 'Erneut versuchen',
  'action.uploadCustom': 'Eigenes hochladen',
  'action.browseLibrary': 'Bibliothek durchsuchen',

  'history.show': 'Letzte Bilder anzeigen ({count})',
  'history.hide': 'Letzte Bilder ausblenden',
  'history.empty': 'Noch nichts da. Deine erzeugten Bilder erscheinen hier.',

  'gen.working': 'Dein Bild wird erstellt…',
  'gen.takesTime': 'Das dauert meist weniger als eine Minute.',
  'gen.noCredits': 'Dein Guthaben ist aufgebraucht. Kaufe mehr, um weiterzumachen.',
  'gen.failed': 'Das hat nicht geklappt. Dein Credit wurde nicht berechnet.',
  'gen.blocked': 'Der Sicherheitsfilter hat das Foto abgelehnt. Versuch ein anderes – dein Credit wurde nicht berechnet.',

  'pay.title': 'Guthaben kaufen',
  'pay.subtitle': 'Credits verfallen nicht.',
  'pay.creditsLabel': '{count} Credits',
  'pay.saved': '{amount} gespart',
  'pay.pay': '{amount} bezahlen',
  'pay.processing': 'Wird verarbeitet…',
  'pay.success': 'Zahlung abgeschlossen. Dein Guthaben wurde gutgeschrieben.',
  'pay.failed': 'Zahlung fehlgeschlagen. Es wurde nichts berechnet.',
  'pay.completeTitle': 'Zahlung abgeschlossen',
  'pay.completeBody': 'Dein Guthaben wurde deinem Konto gutgeschrieben.',

  'error.title': 'Etwas ist schiefgelaufen',
  'error.body': 'Auf der Seite ist ein unerwarteter Fehler aufgetreten. Neu laden hilft meistens.',
  'error.reload': 'Seite neu laden',
  'notFound.title': 'Seite nicht gefunden',
  'notFound.body': 'Diese Adresse gehört zu nichts im Studio.',
  'notFound.home': 'Zum Dashboard',

  'footer.privacy': 'Datenschutzerklärung',
};

export default de;
